import {
  faSpinner,
  faBullhorn,
  faUnlink,
  faFireExtinguisher,
  faThermometerHalf,
  faDesktop,
  faTruck,
  faTrash as faTrashSolid,
  faFan,
  faAddressBook,
  faBook,
  faBooks,
  faSort,
  faSortDown,
  faSortUp,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faStar,
  faHome,
  faComments,
  faCog,
  faChartBar,
  faThLarge,
  faThList,
  faBell,
  faBolt,
  faHeart,
  faMedal,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faEllipsisV,
  faCheck,
  faFile,
  faFilter,
  faShareSquare,
  faUsers,
  faClock,
  faShieldAlt,
  faLock,
  faUserPlus,
  faAlignLeft,
  faUsersCog,
  faClipboardListCheck,
  faTimes as faTimesBold,
  faSlidersUp,
  faRepeat,
  faPencil,
  faExclamationTriangle,
  faThumbsUp,
  faThumbsDown,
  faEnvelopeSquare,
  faPhoneSquare,
  faUsdSquare,
  faBoxOpen,
  faInbox,
  faUser,
  faSignOutAlt,
  faSignInAlt,
  faUpload,
  faHistory,
  faCaretDown,
  faCaretRight,
  faMousePointer,
  faRandom,
  faUserFriends,
  faUserCheck,
  faUserClock,
  faUserLock,
  faDollarSign,
  faCloud,
  faCloudRain,
  faCloudSleet,
  faCloudSnow,
  faClouds,
  faSmog,
  faWind,
  faSun,
  faHurricane,
  faDownload,
  faFileUpload,
  faSearch as faSearchBold,
  faBars as faBarsBold,
  faMapMarkerAlt,
  faImages,
  faUniversity,
  faCreditCard,
  faTools as faToolsSolid,
  faUserHardHat,
  faFolderOpen,
  faArchive,
  faQrcode,
  faCopy,
  faTags,
  faTag,
  faCopyright,
  faStore,
  faJoystick,
  faUndo,
  faClipboardList,
  faCauldron,
  faOven,
  faFaucetDrip,
  faEllipsisH,
  faListAlt,
  faPhoneRotary,
  faMobileAlt,
  faFax,
  faVolumeSlash,
  faVolumeHigh,
  faSignOut,
  faArrowRight,
  faFlag,
  faCalendar as faCalendarSolid,
  faCalendarPlus,
  faGauge,
  faGripVertical,
  faExchange,
  faLightbulb,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faFillDrip,
  faBlog,
  faGift,
  faImage,
  faVideo,
  faPlay,
  faStop,
  faBadgeCheck,
  faInfoCircle as faInfoCircleSold,
  faRouter,
  faChartColumn,
  faCircleExclamation,
  faSquareCheck,
  faCalendarExclamation,
  faCircleDollar,
  faCirclePlus,
  faAngleDown,
  faTableColumns,
  faCalendarDays,
  faLayerGroup as faLayerGroupSolid,
  faRobot,
  faPaperPlane,
  faCommentDots,
  faGasPump,
  faEngine,
  faIdCard,
  faFileLines,
  faShieldCheck,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBars,
  faTimes,
  faEnvelope,
  faPlus,
  faBox,
  faCalendarAlt,
  faTools,
  faTasks,
  faMapMarkedAlt,
  faShoppingCart,
  faLink,
  faCommentsAlt,
  faBuilding,
  faBuildingLock,
  faReceipt,
  faChartLine,
  faUserTie,
  faSearch,
  faAward,
  faEye,
  faWrench,
  faCogs,
  faChargingStation,
  faFileContract,
  faFileAlt,
  faPaperclip,
  faTrash,
  faUserCircle,
  faSlidersUp as faSlidersA,
  faSyncAlt,
  faFlag as faFlagRegular,
  faCheck as faCheckRegular,
  faFileExport,
  faExpandArrowsAlt,
  faExpand,
  faCompress,
  faTimesCircle as faTimesCircleRegular,
  faClipboardListCheck as faClipboardListCheckRegular,
  faChevronRight as faChevronRightRegular,
  faChevronLeft as faChevronLeftRegular,
  faChevronDown as faChevronDownRegular,
  faChevronUp as faChevronUpRegular,
  faCircle as faCircleRegular,
  faBell as faBellRegular,
  faComment,
  faBinoculars,
  faFilePdf,
  faList,
  faPencil as faPencilRegular,
  faPenToSquare,
  faUserTimes,
  faBan,
  faFileInvoice,
  faFileInvoiceDollar,
  faStopwatch,
  faDownload as faDownloadRegular,
  faFilter as faFilterRegular,
  faStar as faStarRegular,
  faCopy as faCopyRegular,
  faCalendarPlus as faCalendarPlusRegular,
  faCalendarLinesPen as faCalendarLinesPenRegular,
  faCamera,
  faBatteryQuarter,
  faBatteryHalf,
  faBatteryFull,
  faSave,
  faDiagramSubtask,
  faFolderGear,
  faCalendarClock,
  faPrint,
  faLayerGroup,
  faLock as faLockRegular,
  faMapLocationDot,
  faChartNetwork,
  faHourglass,
  faTruck as faTruckRegular,
  faUser as faUserRegular,
  faCarSide as faCarSideRegular,
  faArrowRotateRight,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faCircle,
  faInfoCircle,
  faFolderOpen as faFolderOpenLight,
  faLayerPlus,
  faAddressBook as faAddressBookLight,
  faLaptop as faLaptopLight,
  faHeadSideGear as faHeadSideGearLight,
  faChartLine as faChartLineLight,
  faCompassSlash as faCompassSlashLight,
} from '@fortawesome/pro-light-svg-icons';

import {
  faFacebook,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { faUserGear } from '@fortawesome/free-solid-svg-icons';

const fontAwesomeIcons = [
  faUnlink,
  faBars,
  faBarsBold,
  faTimes,
  faBook,
  faBooks,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSearch,
  faSearchBold,
  faStar,
  faStarRegular,
  faHome,
  faComments,
  faCog,
  faChartLine,
  faThLarge,
  faThList,
  faBell,
  faFacebook,
  faXTwitter,
  faLinkedinIn,
  faEnvelope,
  faBolt,
  faHeart,
  faEye,
  faMedal,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faPlus,
  faEllipsisV,
  faCheck,
  faFile,
  faFilter,
  faShareSquare,
  faUsers,
  faClock,
  faShieldAlt,
  faLock,
  faLockRegular,
  faUserPlus,
  faAlignLeft,
  faAddressBook,
  faUsersCog,
  faClipboardListCheck,
  faTools,
  faBuilding,
  faBuildingLock,
  faTimesBold,
  faSlidersUp,
  faRepeat,
  faPencil,
  faExclamationTriangle,
  faThumbsUp,
  faThumbsDown,
  faEnvelopeSquare,
  faPhoneSquare,
  faUsdSquare,
  faBoxOpen,
  faInbox,
  faUser,
  faSignOutAlt,
  faSignInAlt,
  faUpload,
  faHistory,
  faCaretDown,
  faCaretRight,
  faMousePointer,
  faRandom,
  faUserFriends,
  faUserCheck,
  faUserClock,
  faChevronLeft,
  faChartBar,
  faBox,
  faBadgeCheck,
  faCalendarAlt,
  faTasks,
  faMapMarkedAlt,
  faShoppingCart,
  faLink,
  faCommentsAlt,
  faReceipt,
  faUserTie,
  faUserLock,
  faDollarSign,
  faCloud,
  faCloudRain,
  faCloudSleet,
  faCloudSnow,
  faClouds,
  faSmog,
  faWind,
  faSun,
  faHurricane,
  faDownload,
  faFileUpload,
  faCircle,
  faInfoCircle,
  faMapMarkerAlt,
  faImages,
  faAward,
  faCogs,
  faChargingStation,
  faFileContract,
  faFileAlt,
  faPaperclip,
  faWrench,
  faUniversity,
  faCreditCard,
  faToolsSolid,
  faUserHardHat,
  faFolderOpen,
  faArchive,
  faQrcode,
  faBullhorn,
  faTrash,
  faTrashSolid,
  faCopy,
  faCopyRegular,
  faTags,
  faTag,
  faCopyright,
  faStore,
  faJoystick,
  faUndo,
  faClipboardList,
  faInstagram,
  faCauldron,
  faFireExtinguisher,
  faThermometerHalf,
  faOven,
  faFaucetDrip,
  faDesktop,
  faTruck,
  faEllipsisH,
  faFan,
  faListAlt,
  faPhoneRotary,
  faMobileAlt,
  faFax,
  faVolumeSlash,
  faVolumeHigh,
  faSignOut,
  faArrowRight,
  faSlidersA,
  faUserCircle,
  faFlag,
  faCalendarSolid,
  faCalendarPlus,
  faCalendarPlusRegular,
  faCalendarLinesPenRegular,
  faGauge,
  faSyncAlt,
  faFlagRegular,
  faCheckRegular,
  faFileExport,
  faExpandArrowsAlt,
  faExpand,
  faCompress,
  faTimesCircleRegular,
  faClipboardListCheckRegular,
  faGripVertical,
  faChevronRightRegular,
  faChevronLeftRegular,
  faChevronDownRegular,
  faChevronUpRegular,
  faCircleRegular,
  faBellRegular,
  faComment,
  faExchange,
  faLightbulb,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faFillDrip,
  faGift,
  faBlog,
  faBinoculars,
  faFilePdf,
  faImage,
  faVideo,
  faPlay,
  faList,
  faPencilRegular,
  faPenToSquare,
  faUserTimes,
  faBan,
  faFileInvoice,
  faFileInvoiceDollar,
  faStop,
  faStopwatch,
  faDownloadRegular,
  faFilterRegular,
  faInfoCircleSold,
  faCamera,
  faFolderOpenLight,
  faLayerPlus,
  faRouter,
  faBatteryQuarter,
  faBatteryHalf,
  faBatteryFull,
  faSave,
  faChartColumn,
  faDiagramSubtask,
  faFolderGear,
  faCalendarClock,
  faCircleExclamation,
  faSquareCheck,
  faCircleDollar,
  faCalendarExclamation,
  faPrint,
  faCirclePlus,
  faLayerGroup,
  faUserGear,
  faAngleDown,
  faTableColumns,
  faCalendarDays,
  faLayerGroupSolid,
  faMapLocationDot,
  faChartNetwork,
  faHourglass,
  faAddressBookLight,
  faLaptopLight,
  faHeadSideGearLight,
  faChartLineLight,
  faCompassSlashLight,
  faTruckRegular,
  faUserRegular,
  faCarSideRegular,
  faRobot,
  faPaperPlane,
  faCommentDots,
  faGasPump,
  faEngine,
  faIdCard,
  faFileLines,
  faArrowRotateRight,
  faShieldCheck,
];

export default fontAwesomeIcons;
